import { render, staticRenderFns } from "./DlgBranchDelete.vue?vue&type=template&id=4ae131d8&scoped=true"
import script from "./DlgBranchDelete.vue?vue&type=script&lang=js"
export * from "./DlgBranchDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae131d8",
  null
  
)

export default component.exports